// Kannada. Recipe text itself stays in English for Kannada readers (recipes are written in Tamil,
// English and Tanglish), so search examples use English words.
import type { Key } from '../i18n';

export const kn: Record<Key, string> = {
  'nav.main': 'ಮುಖ್ಯ',
  'nav.home': 'ಮುಖಪುಟ',
  'nav.albums': 'ಆಲ್ಬಮ್‌ಗಳು',
  'nav.grocery': 'ದಿನಸಿ',
  'nav.home.label': 'Eat Recipe ಮುಖಪುಟ',
  'common.tryAgain': 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
  'common.tryingAgain': 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸುತ್ತಿದ್ದೇವೆ…',
  'common.back': 'ಹಿಂದೆ',
  'common.cancel': 'ರದ್ದು',
  'common.save': 'ಉಳಿಸಿ',
  'common.done': 'ಮುಗಿಯಿತು',
  'common.loading': 'ಲೋಡ್ ಆಗುತ್ತಿದೆ',
  'common.seeAll': 'ಎಲ್ಲಾ ನೋಡಿ',
  'common.addReel': 'ರೀಲ್ ಸೇರಿಸಿ',
  'common.profile': 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು, ಪ್ರೊಫೈಲ್',
  'common.watchReel': 'ರೀಲ್ ನೋಡಿ ↗',
  'common.veg': 'ಸಸ್ಯಾಹಾರ',
  'common.nonveg': 'ಮಾಂಸಾಹಾರ',
  'common.unsure': 'ಗೊತ್ತಿಲ್ಲ',
  'n.recipes_one': '{n} ರೆಸಿಪಿ',
  'n.recipes': '{n} ರೆಸಿಪಿಗಳು',
  'n.ingredients_one': '{n} ಪದಾರ್ಥ',
  'n.ingredients': '{n} ಪದಾರ್ಥಗಳು',
  'n.steps_one': '{n} ಹಂತ',
  'n.steps': '{n} ಹಂತಗಳು',
  'n.cooked': '{n}× ಮಾಡಿದ್ದೀರಿ',
  'n.cookedOn': '{n}× ಮಾಡಿದ್ದೀರಿ · {date}',
  'verdict.again': 'ಮತ್ತೆ ಮಾಡುತ್ತೇವೆ',
  'verdict.ok': 'ಪರವಾಗಿಲ್ಲ',
  'verdict.no': 'ನಮಗೆ ಇಷ್ಟವಾಗಲಿಲ್ಲ',

  'lang.title': 'ನಿಮ್ಮ ಭಾಷೆ ಆರಿಸಿ',
  'lang.body': 'ಆ್ಯಪ್‌ನ ಪದಗಳು ಮತ್ತು Instagram ಬಾಟ್‌ನ ಉತ್ತರಗಳು ಈ ಭಾಷೆಯಲ್ಲಿರುತ್ತವೆ. ಸೆಟ್ಟಿಂಗ್‌ಗಳಲ್ಲಿ ಯಾವಾಗ ಬೇಕಾದರೂ ಬದಲಿಸಿ.',
  'lang.ta': 'ರೆಸಿಪಿಗಳು ಮತ್ತು ಆ್ಯಪ್ ತಮಿಳಿನಲ್ಲಿ',
  'lang.en': 'ರೆಸಿಪಿಗಳು ಮತ್ತು ಆ್ಯಪ್ ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ',
  'lang.tg': 'thakkali, vengayam ರೀತಿಯ ಹೆಸರುಗಳು · ಆ್ಯಪ್ ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ',
  'lang.continue': 'ಮುಂದುವರಿಸಿ',
  'lang.saveFailed': 'ನಿಮ್ಮ ಭಾಷೆ ಉಳಿಸಲಾಗಲಿಲ್ಲ. ಸಂಪರ್ಕ ಪರಿಶೀಲಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',

  'greet.tiffin': 'ಶುಭೋದಯ{name} · ತಿಂಡಿ ಸಮಯ',
  'greet.lunch': 'ನಮಸ್ಕಾರ{name} · ಊಟದ ಸಮಯ',
  'greet.teatime': 'ಶುಭ ಸಂಜೆ{name} · ಟೀ ಸಮಯ',
  'greet.dinner': 'ಶುಭ ಸಂಜೆ{name} · ರಾತ್ರಿ ಊಟದ ಸಮಯ',
  'greet.latenight': 'ತಡರಾತ್ರಿ{name} · ಏನಾದರೂ ಬೇಗ?',
  'home.title': 'ಇವತ್ತು ಏನು ತಿನ್ನಬೇಕು ಅನಿಸುತ್ತಿದೆ?',
  'home.search': '{n} ರೆಸಿಪಿಗಳಲ್ಲಿ ಹುಡುಕಿ · tomato · rasam',
  'home.searchEmpty': 'ಹುಡುಕಿ · tomato · rasam',
  'home.mood': 'ಮೂಡ್‌ಗೆ ತಕ್ಕಂತೆ',
  'home.surprise': 'ನಿರ್ಧರಿಸಲಾಗುತ್ತಿಲ್ಲವೇ? ಏನಾದರೂ ಸೂಚಿಸು',
  'home.howAbout': 'ಇದು ಹೇಗಿದೆ…',
  'home.cookThis': 'ಇದನ್ನು ಮಾಡೋಣ',
  'home.another': 'ಇನ್ನೊಂದು',
  'home.cookAgain': 'ಮತ್ತೆ ಮಾಡಿ',
  'home.cookAgainHint': 'ನೀವು “ಮತ್ತೆ ಮಾಡುತ್ತೇವೆ” ಎಂದಿದ್ದೀರಿ',
  'home.yourAlbums': 'ನಿಮ್ಮ ಆಲ್ಬಮ್‌ಗಳು',
  'home.justSaved': 'ಈಗಷ್ಟೇ ಉಳಿಸಿದವು',
  'home.allByDate': 'ದಿನಾಂಕದ ಪ್ರಕಾರ ಎಲ್ಲಾ',
  'home.readingFrom': '{who} ಅವರ ರೀಲ್ ಓದುತ್ತಿದ್ದೇವೆ',
  'home.reading': 'ರೀಲ್ ಓದುತ್ತಿದ್ದೇವೆ',
  'home.landsInAlbums': 'ಸಿದ್ಧವಾದ ತಕ್ಷಣ ಸರಿಯಾದ ಆಲ್ಬಮ್‌ಗಳಿಗೆ ಹೋಗುತ್ತದೆ',
  'home.addedTo': '{albums} ಗೆ ಸೇರಿಸಲಾಗಿದೆ',
  'home.noRecipe': 'ಈ ರೀಲ್‌ನಲ್ಲಿ ರೆಸಿಪಿ ಸಿಗಲಿಲ್ಲ',
  'home.failed': 'ಈ ರೀಲ್ ಓದಲಾಗಲಿಲ್ಲ · ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಲು ಟ್ಯಾಪ್ ಮಾಡಿ',
  'home.newTitle': 'ನಿಮ್ಮ ರೆಸಿಪಿಗಳು ಇಲ್ಲಿ, ಮೂಡ್ ಪ್ರಕಾರ ವಿಂಗಡಿಸಿ ಬರುತ್ತವೆ',
  'home.newBody': 'Instagram‌ನಲ್ಲಿ ಯಾವುದೇ ಅಡುಗೆ ರೀಲ್ ಮೇಲೆ ➤ ಟ್ಯಾಪ್ ಮಾಡಿ @eat.recipe ಗೆ ಕಳುಹಿಸಿ. ಒಂದು ನಿಮಿಷದಲ್ಲಿ ರೆಸಿಪಿ ಇಲ್ಲಿರುತ್ತದೆ.',
  'home.openInstagram': '@eat.recipe ಗೆ ಮೆಸೇಜ್ ಮಾಡಿ',
  'home.pasteLink': 'ಬದಲಿಗೆ ರೀಲ್ ಲಿಂಕ್ ಪೇಸ್ಟ್ ಮಾಡಿ',
  'reason.never_tried': 'ಉಳಿಸಿದ್ದೀರಿ, ಎಂದೂ ಮಾಡಿಲ್ಲ',
  'reason.make_again_days': 'ಮತ್ತೆ ಮಾಡುತ್ತೇವೆ ಎಂದಿದ್ದೀರಿ · {n} ದಿನಗಳ ಹಿಂದೆ',
  'reason.make_again_weeks': 'ಮತ್ತೆ ಮಾಡುತ್ತೇವೆ ಎಂದಿದ್ದೀರಿ · {n} ವಾರಗಳ ಹಿಂದೆ',
  'reason.not_cooked_days': '{n} ದಿನಗಳಿಂದ ಮಾಡಿಲ್ಲ',
  'reason.not_cooked_weeks': '{n} ವಾರಗಳಿಂದ ಮಾಡಿಲ್ಲ',
  'reason.meal.tiffin': 'ತಿಂಡಿಗೆ ಚೆನ್ನಾಗಿದೆ',
  'reason.meal.lunch': 'ಊಟಕ್ಕೆ ಚೆನ್ನಾಗಿದೆ',
  'reason.meal.teatime': 'ಟೀ ಜೊತೆ ಚೆನ್ನಾಗಿದೆ',
  'reason.meal.dinner': 'ರಾತ್ರಿ ಊಟಕ್ಕೆ ಚೆನ್ನಾಗಿದೆ',
  'reason.meal.latenight': 'ತಡರಾತ್ರಿಗೆ ಬೇಗ',
  'surprise.none': 'ಇಲ್ಲಿ ಸೂಚಿಸಲು ಇನ್ನೂ ಏನೂ ಇಲ್ಲ.',

  'albums.title': 'ಆಲ್ಬಮ್‌ಗಳು',
  'albums.sub': '{n} ರೆಸಿಪಿಗಳು, ಬಂದ ತಕ್ಷಣ ನಿಮಗಾಗಿ ವಿಂಗಡಿಸಲಾಗಿದೆ',
  'albums.sub_one': '1 ರೆಸಿಪಿ, ಬಂದ ತಕ್ಷಣ ನಿಮಗಾಗಿ ವಿಂಗಡಿಸಲಾಗಿದೆ',
  'albums.search': 'ಎಲ್ಲಾ ರೆಸಿಪಿಗಳಲ್ಲಿ ಹುಡುಕಿ',
  'albums.mine': 'ನೀವು ಮಾಡಿದವು',
  'albums.new': 'ಹೊಸ ಆಲ್ಬಮ್',
  'albums.browse': 'ಹೀಗೆ ನೋಡಿ',
  'albums.view': 'ಆಲ್ಬಮ್ ವೀಕ್ಷಣೆ',
  'view.craving': 'ಮೂಡ್',
  'view.region': 'ಪ್ರದೇಶ',
  'view.meal': 'ಊಟ',
  'view.timeline': 'ಟೈಮ್‌ಲೈನ್',
  'hint.craving': 'ನಿಮ್ಮ ಮೂಡ್ ಪ್ರಕಾರ ಆರಿಸಿ — ಖಾರ, ಹಿತ, ಬೇಗ ಅಥವಾ ಹಗುರ.',
  'hint.region': 'ಒಂದು ಊರಿನ ರುಚಿ — ಚೆಟ್ಟಿನಾಡ್ ಅಡುಗೆಮನೆಯಿಂದ ಜಾಗತಿಕ ತಟ್ಟೆಯವರೆಗೆ.',
  'hint.meal': 'ಈಗ ಯಾವ ಸಮಯ? ತಿಂಡಿಯಿಂದ ರಾತ್ರಿ ಊಟದವರೆಗೆ, ಜೊತೆಗೆ ಲಂಚ್‌ಬಾಕ್ಸ್.',
  'hint.timeline': 'ನೀವು ಹಂಚಿದ ಪ್ರತಿಯೊಂದು ರೀಲ್, ಉಳಿಸಿದ ಕ್ರಮದಲ್ಲಿ.',
  'albums.empty': 'ಇಲ್ಲಿ ಇನ್ನೂ ಏನೂ ಇಲ್ಲ. @eat.recipe ಗೆ ಕೆಲವು ರೀಲ್ ಕಳುಹಿಸಿ, ಅವು ತಾವೇ ಆಲ್ಬಮ್‌ಗಳಿಗೆ ವಿಂಗಡಣೆಯಾಗುತ್ತವೆ.',
  'tl.week': 'ಈ ವಾರ',
  'tl.month_rest': 'ಈ ತಿಂಗಳ ಹಿಂದೆ',
  'tl.before': 'ಅದಕ್ಕೂ ಮೊದಲು',
  'tl.reading': '{n} ಓದುತ್ತಿದ್ದೇವೆ…',

  'kind.craving': 'ಮೂಡ್',
  'kind.region': 'ಪ್ರದೇಶ',
  'kind.meal': 'ಊಟ',
  'kind.mine': 'ನಿಮ್ಮ ಆಲ್ಬಮ್',
  'album.stats': '{n} ರೆಸಿಪಿಗಳು · {c} ಮಾಡಿದ್ದು · {u} ಇನ್ನೂ ಪ್ರಯತ್ನಿಸಿಲ್ಲ',
  'album.stats_one': '1 ರೆಸಿಪಿ · {c} ಮಾಡಿದ್ದು · {u} ಇನ್ನೂ ಪ್ರಯತ್ನಿಸಿಲ್ಲ',
  'album.pin': 'ಮುಖಪುಟಕ್ಕೆ ಪಿನ್ ಮಾಡಿ',
  'album.unpin': 'ಮುಖಪುಟದಿಂದ ತೆಗೆಯಿರಿ',
  'album.pinned': 'ಮುಖಪುಟಕ್ಕೆ ಪಿನ್ ಮಾಡಲಾಗಿದೆ',
  'album.unpinned': 'ಮುಖಪುಟದಿಂದ ತೆಗೆಯಲಾಗಿದೆ',
  'album.backToAlbums': 'ಆಲ್ಬಮ್‌ಗಳಿಗೆ ಹಿಂದೆ',
  'filter.label': 'ರೆಸಿಪಿಗಳನ್ನು ಫಿಲ್ಟರ್ ಮಾಡಿ',
  'filter.all': 'ಎಲ್ಲಾ',
  'filter.untried': 'ಇನ್ನೂ ಪ್ರಯತ್ನಿಸಿಲ್ಲ',
  'album.pick': 'ಇದರಿಂದ ನನಗಾಗಿ ಒಂದನ್ನು ಆರಿಸು',
  'album.favourites': 'ನಿಮ್ಮ ಮೆಚ್ಚಿನವು',
  'album.notTried': 'ಇನ್ನೂ ಪ್ರಯತ್ನಿಸಿಲ್ಲ',
  'album.cookedBefore': 'ಹಿಂದೆ ಮಾಡಿದವು',
  'album.saved': '{date} ರಂದು ಉಳಿಸಿದ್ದು',
  'album.shop': 'ಇವುಗಳಲ್ಲಿ ಕೆಲವಕ್ಕೆ ಖರೀದಿಸಿ',
  'album.shopTitle': 'ನೀವು ಯಾವುದನ್ನು ಮಾಡುತ್ತಿದ್ದೀರಿ?',
  'album.shopGo': 'ದಿನಸಿ ಪಟ್ಟಿ ಮಾಡಿ · {n}',
  'album.empty': 'ಇಲ್ಲಿ ಇನ್ನೂ ರೆಸಿಪಿಗಳಿಲ್ಲ.',
  'album.emptyMine': 'ಯಾವುದಾದರೂ ರೆಸಿಪಿ ತೆರೆದು “ಆಲ್ಬಮ್‌ಗೆ ಸೇರಿಸಿ” ಟ್ಯಾಪ್ ಮಾಡಿ.',
  'album.noMatch': 'ಈ ಫಿಲ್ಟರ್‌ಗೆ ಯಾವುದೂ ಹೊಂದುತ್ತಿಲ್ಲ.',
  'album.showAll': 'ಎಲ್ಲಾ ತೋರಿಸಿ',
  'album.rename': 'ಹೆಸರು ಬದಲಿಸಿ',
  'album.delete': 'ಆಲ್ಬಮ್ ಅಳಿಸಿ',
  'album.deleteConfirm': 'ಅಳಿಸಲು ಮತ್ತೆ ಟ್ಯಾಪ್ ಮಾಡಿ — ರೆಸಿಪಿಗಳು ನಿಮ್ಮ ಲೈಬ್ರರಿಯಲ್ಲೇ ಇರುತ್ತವೆ',
  'album.notFound': 'ಈ ಆಲ್ಬಮ್ ಈಗ ಇಲ್ಲ.',
  'album.nameLabel': 'ಆಲ್ಬಮ್ ಹೆಸರು',
  'album.namePlaceholder': 'ಅಮ್ಮನ ಶೈಲಿ · ಭಾನುವಾರ ಸ್ಪೆಷಲ್',
  'album.create': 'ಆಲ್ಬಮ್ ರಚಿಸಿ',
  'album.created': 'ಆಲ್ಬಮ್ ರಚಿಸಲಾಗಿದೆ',

  'timeline.title': 'ದಿನಾಂಕದ ಪ್ರಕಾರ ಎಲ್ಲಾ',
  'timeline.newest': 'ಹೊಸದು ಮೊದಲು',
  'timeline.search': 'ರೆಸಿಪಿ ಹುಡುಕಿ',
  'timeline.empty': 'ನಿಮ್ಮ ಲೈಬ್ರರಿ ಖಾಲಿಯಾಗಿದೆ',
  'timeline.emptyBody': 'Instagram‌ನಲ್ಲಿ ಯಾವುದೇ ಅಡುಗೆ ರೀಲ್ ಮೇಲೆ ➤ ಟ್ಯಾಪ್ ಮಾಡಿ @eat.recipe ಗೆ ಕಳುಹಿಸಿ. ಕೆಲವೇ ಕ್ಷಣಗಳಲ್ಲಿ ರೆಸಿಪಿ ಇಲ್ಲಿ ಕಾಣಿಸುತ್ತದೆ.',
  'timeline.noMatch': 'ಈ ಫಿಲ್ಟರ್‌ಗೆ ಯಾವುದೂ ಹೊಂದುತ್ತಿಲ್ಲ.',
  'timeline.showAll': 'ಎಲ್ಲಾ ತೋರಿಸಿ',
  'timeline.retrying': 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸುತ್ತಿದ್ದೇವೆ — ರೆಸಿಪಿ ಇಲ್ಲಿ ಬರುತ್ತದೆ',
  'timeline.scriptHint': 'ಹೆಸರುಗಳು {script}ನಲ್ಲಿ; ಬದಲಿಸಲು ಟ್ಯಾಪ್ ಮಾಡಿ',

  'card.reading': 'ರೀಲ್ ಓದುತ್ತಿದ್ದೇವೆ',
  'card.arrives': 'ರೆಸಿಪಿ ಕೆಲವೇ ಕ್ಷಣಗಳಲ್ಲಿ ಬರುತ್ತದೆ',
  'card.progress': 'ಪ್ರಕ್ರಿಯೆಯ ಪ್ರಗತಿ',
  'card.stages': 'ಸಿಕ್ಕಿತು · ಕೇಳುತ್ತಿದ್ದೇವೆ · ಬರೆಯುತ್ತಿದ್ದೇವೆ',
  'card.failed': 'ಈ ರೀಲ್ ಓದಲಾಗಲಿಲ್ಲ',
  'card.linkSafe': 'ನಿಮ್ಮ ಲಿಂಕ್ ಸುರಕ್ಷಿತವಾಗಿದೆ.',
  'card.private': 'ರೀಲ್ ಖಾಸಗಿಯಾಗಿದೆ ಅಥವಾ ತೆಗೆದುಹಾಕಲಾಗಿದೆ.',
  'card.dropped': 'ಕೇಳುತ್ತಿರುವಾಗ ಸಂಪರ್ಕ ಕಡಿತವಾಯಿತು.',
  'card.wrong': 'ಕೇಳುತ್ತಿರುವಾಗ ಏನೋ ತಪ್ಪಾಯಿತು.',
  'card.noRecipe': 'ಈ ರೀಲ್‌ನಲ್ಲಿ ರೆಸಿಪಿ ಇಲ್ಲ',
  'card.noRecipeBody': 'ಇದರಲ್ಲಿ ಒಂದು ಖಾದ್ಯದ ಬಗ್ಗೆ ಮಾತಿದೆ, ಆದರೆ ಮಾಡುವ ವಿಧಾನ ತೋರಿಸಿಲ್ಲ. ಲಿಂಕ್ ನಿಮಗಾಗಿ ಇಟ್ಟಿದ್ದೇವೆ.',
  'card.ingredientsOnly': 'ಪದಾರ್ಥಗಳು ಮಾತ್ರ — ರೀಲ್‌ನಲ್ಲಿ ಹಂತಗಳನ್ನು ಹೇಳಿಲ್ಲ',
  'card.taVoice': 'ತಮಿಳು ಧ್ವನಿ',
  'card.enVoice': 'ಇಂಗ್ಲಿಷ್ ಧ್ವನಿ',

  'add.title': 'ರೀಲ್ ಸೇರಿಸಿ',
  'add.label': 'Instagram ರೀಲ್ ಲಿಂಕ್ ಪೇಸ್ಟ್ ಮಾಡಿ',
  'add.adding': 'ಸೇರಿಸುತ್ತಿದ್ದೇವೆ…',
  'add.submit': 'ನನ್ನ ಲೈಬ್ರರಿಗೆ ಸೇರಿಸಿ',
  'add.or': 'ಅಥವಾ, Instagram‌ನಲ್ಲಿ ಯಾವುದೇ ರೀಲ್ ಇಲ್ಲಿಗೆ ಹಂಚಿಕೊಳ್ಳಿ',
  'add.added': 'ಸಿಕ್ಕಿತು — ರೀಲ್ ಓದುತ್ತಿದ್ದೇವೆ',

  'search.label': 'ರೆಸಿಪಿ ಹುಡುಕಿ',
  'search.back': 'ಹಿಂದೆ',
  'search.clear': 'ಹುಡುಕಾಟ ಅಳಿಸಿ',
  'search.also': 'ಇವನ್ನೂ ಹುಡುಕುತ್ತಿದ್ದೇವೆ',
  'search.count_one': '1 ರೆಸಿಪಿ',
  'search.count': '{n} ರೆಸಿಪಿಗಳು',
  'search.idle': 'ಖಾದ್ಯ, ಪದಾರ್ಥ ಅಥವಾ ಕ್ರಿಯೇಟರ್ ಹೆಸರಿನಿಂದ ಹುಡುಕಿ.',
  'search.none': 'ಏನೂ ಸಿಗಲಿಲ್ಲವೇ?',
  'search.tryScripts': 'ಇಂಗ್ಲಿಷ್ ಪದಗಳಿಂದ ಹುಡುಕಿ — ಉದಾ. tomato ಅಥವಾ rasam. ರೆಸಿಪಿಗಳನ್ನು ತಮಿಳು, ಇಂಗ್ಲಿಷ್, Tanglish ನಲ್ಲಿ ಬರೆಯಲಾಗುತ್ತದೆ.',
  'match.dish': 'ಖಾದ್ಯದ ಹೆಸರು ಹೊಂದಿದೆ',
  'match.ingredient': 'ಪದಾರ್ಥ:',
  'match.transcript': 'ರೀಲ್‌ನಲ್ಲಿ ಹೇಳಿದ್ದು:',
  'match.caption': 'ಕ್ಯಾಪ್ಶನ್:',
  'match.tag': '“{t}” ಟ್ಯಾಗ್',
  'match.creator': '{t} ಅವರಿಂದ',
  'match.similar': 'ಹೋಲುವ ಕಾಗುಣಿತ',

  'recipe.notInLibrary': 'ಈ ರೆಸಿಪಿ ನಿಮ್ಮ ಲೈಬ್ರರಿಯಲ್ಲಿಲ್ಲ.',
  'recipe.share': 'ರೆಸಿಪಿ ಹಂಚಿಕೊಳ್ಳಿ',
  'recipe.copied': 'ಲಿಂಕ್ ಕಾಪಿ ಆಯಿತು',
  'recipe.reelLength': '{d} ರೀಲ್',
  'recipe.taVoice': 'ತಮಿಳು ಧ್ವನಿ',
  'recipe.enVoice': 'ಇಂಗ್ಲಿಷ್ ಧ್ವನಿ',
  'recipe.cookedLast': '{n}× ಮಾಡಿದ್ದೀರಿ · ಕೊನೆಯದಾಗಿ {date}',
  'recipe.today': 'ಇಂದು',
  'recipe.from': 'ಈ ರೀಲ್‌ನಿಂದ ರೆಸಿಪಿ:',
  'recipe.cookMode': 'ಕುಕ್ ಮೋಡ್',
  'recipe.addGrocery': 'ದಿನಸಿ ಪಟ್ಟಿಗೆ ಸೇರಿಸಿ',
  'recipe.inGrocery': 'ನಿಮ್ಮ ದಿನಸಿ ಪಟ್ಟಿಯಲ್ಲಿದೆ ✓',
  'recipe.groceryAdded': 'ದಿನಸಿ ಪಟ್ಟಿಗೆ ಸೇರಿಸಲಾಗಿದೆ',
  'recipe.groceryRemoved': 'ದಿನಸಿ ಪಟ್ಟಿಯಿಂದ ತೆಗೆಯಲಾಗಿದೆ',
  'swipe.add': 'ದಿನಸಿಗೆ ಸೇರಿಸಿ',
  'swipe.remove': 'ದಿನಸಿಯಿಂದ ತೆಗೆಯಿರಿ',
  'grocery.swipeHint': 'ಸಲಹೆ: ರೆಸಿಪಿಯನ್ನು ಬಲಕ್ಕೆ ಸ್ವೈಪ್ ಮಾಡಿದರೆ ಇಲ್ಲಿ ಸೇರುತ್ತದೆ.',
  'recipe.playReel': 'ರೀಲ್ ಇಲ್ಲೇ ಪ್ಲೇ ಮಾಡಿ',
  'recipe.fullScreen': 'ಪೂರ್ಣ ಪರದೆ',
  'recipe.closeReel': 'ರೀಲ್ ಮುಚ್ಚಿ',
  'recipe.addAlbum': 'ಆಲ್ಬಮ್‌ಗೆ ಸೇರಿಸಿ',
  'recipe.inAlbums_one': '1 ಆಲ್ಬಮ್‌ನಲ್ಲಿ',
  'recipe.inAlbums': '{n} ಆಲ್ಬಮ್‌ಗಳಲ್ಲಿ',
  'recipe.script': 'ರೆಸಿಪಿ ಲಿಪಿ',
  'recipe.ingredients': 'ಪದಾರ್ಥಗಳು',
  'recipe.inHand': '{total} ರಲ್ಲಿ {n} ಕೈಯಲ್ಲಿವೆ',
  'recipe.steps': 'ಮಾಡುವ ವಿಧಾನ',
  'recipe.tgSteps': 'ಹಂತಗಳು ಇಂಗ್ಲಿಷ್ ಮತ್ತು ತಮಿಳಿನಲ್ಲಿ ಮಾತ್ರ — ಇಂಗ್ಲಿಷ್ ತೋರಿಸುತ್ತಿದ್ದೇವೆ.',
  'recipe.noSteps': 'ರೀಲ್‌ನಲ್ಲಿ ಹಂತಗಳನ್ನು ಹೇಳಿಲ್ಲ — ವಿಧಾನಕ್ಕಾಗಿ ರೀಲ್ ನೋಡಿ.',
  'recipe.caption': 'ಕ್ರಿಯೇಟರ್ ಕ್ಯಾಪ್ಶನ್',
  'recipe.says': 'ರೀಲ್‌ನಲ್ಲಿ ಏನು ಹೇಳಿದ್ದಾರೆ',
  'recipe.rough': 'ರೀಲ್‌ನಿಂದ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಬರೆಯಲಾಗಿದೆ; ಕೆಲವೆಡೆ ಸ್ಪಷ್ಟವಿಲ್ಲದಿರಬಹುದು.',
  'recipe.noRecipe': 'ಈ ರೀಲ್‌ನಲ್ಲಿ ರೆಸಿಪಿ ಸಿಗಲಿಲ್ಲ.',
  'recipe.readingTitle': 'ರೆಸಿಪಿ ಕೆಲವೇ ಕ್ಷಣಗಳಲ್ಲಿ ಇಲ್ಲಿ ಬರುತ್ತದೆ',
  'recipe.failedBody': 'ನಿಮ್ಮ ಲಿಂಕ್ ಸುರಕ್ಷಿತವಾಗಿದೆ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿದರೆ ಸಾಮಾನ್ಯವಾಗಿ ಕೆಲಸ ಮಾಡುತ್ತದೆ.',
  'recipe.remove': 'ನನ್ನ ಲೈಬ್ರರಿಯಿಂದ ತೆಗೆಯಿರಿ',
  'recipe.removeConfirm': 'ತೆಗೆಯಲು ಮತ್ತೆ ಟ್ಯಾಪ್ ಮಾಡಿ',
  'recipe.removeNote': 'ಈ ರೆಸಿಪಿಯ ನಿಮ್ಮ ಟಿಪ್ಪಣಿಗಳೂ ಅಳಿಸಲ್ಪಡುತ್ತವೆ.',
  'recipe.removeKeep': 'ಇದನ್ನು ಉಳಿಸಿದ ಇತರರಿಗೆ ರೆಸಿಪಿ ಲಭ್ಯವಿರುತ್ತದೆ.',
  'albumSheet.title': 'ಆಲ್ಬಮ್‌ಗೆ ಸೇರಿಸಿ',
  'albumSheet.none': 'ನೀವು ಇನ್ನೂ ಆಲ್ಬಮ್ ಮಾಡಿಲ್ಲ.',
  'albumSheet.added': '{name} ಗೆ ಸೇರಿಸಲಾಗಿದೆ',
  'albumSheet.removed': '{name} ನಿಂದ ತೆಗೆಯಲಾಗಿದೆ',
  'notes.title': 'ನನ್ನ ಅಡುಗೆಮನೆ ಟಿಪ್ಪಣಿಗಳು',
  'notes.private': 'ನಿಮಗೆ ಮಾತ್ರ',
  'notes.cookedToday': 'ಇಂದು ಮಾಡಿದ್ದು ✓',
  'notes.cookToday': 'ನಾನು ಇಂದು ಇದನ್ನು ಮಾಡಿದೆ',
  'notes.logged_one': 'ದಾಖಲಾಯಿತು · ಒಟ್ಟು 1 ಬಾರಿ · ಹಿಂಪಡೆಯಲು ಮತ್ತೆ ಟ್ಯಾಪ್ ಮಾಡಿ',
  'notes.logged': 'ದಾಖಲಾಯಿತು · ಒಟ್ಟು {n} ಬಾರಿ · ಹಿಂಪಡೆಯಲು ಮತ್ತೆ ಟ್ಯಾಪ್ ಮಾಡಿ',
  'notes.cookedBefore_one': 'ಒಮ್ಮೆ ಮಾಡಿದ್ದೀರಿ · ಕೊನೆಯದಾಗಿ {date}',
  'notes.cookedBefore': '{n} ಬಾರಿ ಮಾಡಿದ್ದೀರಿ · ಕೊನೆಯದಾಗಿ {date}',
  'notes.notYet': 'ಇನ್ನೂ ಮಾಡಿಲ್ಲ',
  'notes.turnOut': 'ಹೇಗೆ ಬಂತು?',
  'notes.next': 'ಮುಂದಿನ ಬಾರಿಗೆ ಟಿಪ್ಪಣಿ',
  'notes.placeholder': 'ಖಾರ ಕಡಿಮೆ, ಇನ್ನೊಂದು ಟೊಮೆಟೊ…',
  'notes.save': 'ಟಿಪ್ಪಣಿ ಉಳಿಸಿ',
  'notes.delete': 'ಟಿಪ್ಪಣಿ ಅಳಿಸಿ',
  'notes.today': 'ಇಂದು',

  'cook.exit': 'ನಿರ್ಗಮಿಸಿ',
  'cook.awake': 'ಪರದೆ ಆನ್ ಆಗಿರುತ್ತದೆ',
  'cook.keepOn': 'ಪರದೆ ಆನ್ ಇಡಿ',
  'cook.switch': 'ಹಂತಗಳ ಭಾಷೆ ಬದಲಿಸಿ',
  'cook.progress': 'ಹಂತಗಳ ಪ್ರಗತಿ',
  'cook.step': 'ಹಂತ',
  'cook.forStep': 'ಈ ಹಂತಕ್ಕೆ ಬೇಕಾದವು',
  'cook.prev': 'ಹಿಂದಿನ ಹಂತ',
  'cook.next': 'ಮುಂದಿನ ಹಂತ',
  'cook.noSteps': 'ಈ ರೆಸಿಪಿಯಲ್ಲಿ ಜೊತೆಯಾಗಿ ಮಾಡಲು ಹಂತಗಳಿಲ್ಲ.',
  'cook.backToRecipe': 'ರೆಸಿಪಿಗೆ ಹಿಂದೆ',

  'grocery.title': 'ದಿನಸಿ ಪಟ್ಟಿ',
  'grocery.summary': '{n} ವಸ್ತುಗಳು · {b} ಚೀಲದಲ್ಲಿ · {r} ರೆಸಿಪಿಗಳಿಂದ',
  'grocery.summary_one': '{n} ವಸ್ತುಗಳು · {b} ಚೀಲದಲ್ಲಿ · 1 ರೆಸಿಪಿಯಿಂದ',
  'grocery.addRecipes': '+ ರೆಸಿಪಿಗಳು',
  'grocery.emptyTitle': 'ಇನ್ನೂ ಕೊಳ್ಳಲು ಏನೂ ಇಲ್ಲ',
  'grocery.emptyBody': 'ಯಾವುದಾದರೂ ರೆಸಿಪಿ ತೆರೆದು “ದಿನಸಿ ಪಟ್ಟಿಗೆ ಸೇರಿಸಿ” ಟ್ಯಾಪ್ ಮಾಡಿ. ಬೇರೆ ಬೇರೆ ರೆಸಿಪಿಗಳ ಒಂದೇ ಪದಾರ್ಥ ಒಂದೇ ಸಾಲಿನಲ್ಲಿ ಸೇರುತ್ತದೆ.',
  'grocery.bringBack': '{n} ರೆಸಿಪಿಗಳನ್ನು ಮರಳಿ ತನ್ನಿ',
  'grocery.bringBack_one': '1 ರೆಸಿಪಿಯನ್ನು ಮರಳಿ ತನ್ನಿ',
  'grocery.goRecipes': 'ನನ್ನ ರೆಸಿಪಿಗಳಿಗೆ ಹೋಗಿ',
  'grocery.remove': '{dish} ತೆಗೆಯಿರಿ',
  'grocery.skipped': '{n} ರೆಸಿಪಿಗಳಿಗೆ ಇನ್ನೂ ಪದಾರ್ಥಗಳ ಪಟ್ಟಿ ಇಲ್ಲ.',
  'grocery.skipped_one': '1 ರೆಸಿಪಿಗೆ ಇನ್ನೂ ಪದಾರ್ಥಗಳ ಪಟ್ಟಿ ಇಲ್ಲ.',
  'grocery.hidePantry': 'ಮನೆಯಲ್ಲಿರುವ ಸಾಮಾನ್ಯ ವಸ್ತುಗಳನ್ನು ಮರೆಮಾಡಿ',
  'grocery.hidden': '{n} ಮರೆಮಾಡಲಾಗಿದೆ: {names}',
  'grocery.nothingHidden': 'ಮರೆಮಾಡಲು ಏನೂ ಇಲ್ಲ',
  'grocery.showingBasics': 'ಉಪ್ಪು, ಎಣ್ಣೆ ಮತ್ತು ಇತರ ಸಾಮಾನ್ಯ ವಸ್ತುಗಳನ್ನು ತೋರಿಸುತ್ತಿದ್ದೇವೆ',
  'grocery.vegetables': 'ತರಕಾರಿಗಳು',
  'grocery.spices': 'ಮಸಾಲೆಗಳು',
  'grocery.others': 'ಇತರೆ',
  'grocery.nRecipes': '{n} ರೆಸಿಪಿಗಳು',
  'grocery.asNeeded': 'ಬೇಕಾದಷ್ಟು',
  'grocery.copy': 'ಪಟ್ಟಿ ಕಾಪಿ ಮಾಡಿ',
  'grocery.copied': 'ಕಾಪಿ ಆಯಿತು — ಎಲ್ಲಿ ಬೇಕಾದರೂ ಪೇಸ್ಟ್ ಮಾಡಿ',
  'grocery.copyFailed': 'ಈ ಸಾಧನದಲ್ಲಿ ಕಾಪಿ ಆಗಲಿಲ್ಲ',
  'grocery.whatsapp': 'WhatsApp‌ನಲ್ಲಿ ಹಂಚಿಕೊಳ್ಳಿ',
  'grocery.later': 'ದಿನಸಿ ಆ್ಯಪ್‌ನಿಂದ ಆರ್ಡರ್ — ಶೀಘ್ರದಲ್ಲೇ',
  'grocery.textTitle': 'ದಿನಸಿ ಪಟ್ಟಿ — Eat Recipe',

  'settings.title': 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
  'settings.account': 'ನಿಮ್ಮ ಖಾತೆ',
  'settings.via': 'Instagram DM ಮೂಲಕ ಸೈನ್ ಇನ್',
  'settings.language': 'ಭಾಷೆ',
  'settings.languageHint': 'ಆ್ಯಪ್ ಮತ್ತು ಬಾಟ್ ಉತ್ತರಗಳು. ರೆಸಿಪಿಗಳು ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ ಕಾಣಿಸುತ್ತವೆ.',
  'settings.saved': 'ಉಳಿಸಲಾಗಿದೆ',
  'settings.install': 'ಹೋಮ್ ಸ್ಕ್ರೀನ್‌ಗೆ ಸೇರಿಸಿ',
  'settings.installBody': 'ಆ್ಯಪ್‌ನಂತೆ ತೆರೆಯುತ್ತದೆ, ಸೈನ್ ಇನ್ ಆಗಿಯೇ ಇರುತ್ತದೆ.',
  'settings.installIOS': 'Safari‌ನಲ್ಲಿ Share ಟ್ಯಾಪ್ ಮಾಡಿ, ನಂತರ “Add to Home Screen”.',
  'settings.installBtn': 'Eat Recipe ಸೇರಿಸಿ',
  'install.later': 'ಈಗ ಬೇಡ',
  'install.android': 'ಬ್ರೌಸರ್ ಮೆನುವಿನಲ್ಲಿ (⋮) “Install app” ಅಥವಾ “Add to Home screen” ಟ್ಯಾಪ್ ಮಾಡಿ.',
  'settings.privacy': 'ಗೌಪ್ಯತಾ ನೀತಿ ↗',
  'settings.deletion': 'ನಿಮ್ಮ ಡೇಟಾ ಹೇಗೆ ಅಳಿಸಲಾಗುತ್ತದೆ ↗',
  'settings.signOut': 'ಸೈನ್ ಔಟ್',
  'settings.delete': 'ನನ್ನ ಖಾತೆ ಅಳಿಸಿ',
  'settings.deleteConfirm': 'ಎಲ್ಲವನ್ನೂ ಅಳಿಸಲು ಮತ್ತೆ ಟ್ಯಾಪ್ ಮಾಡಿ',
  'settings.deleteNote': 'ನಿಮ್ಮ ಲೈಬ್ರರಿ, ಟಿಪ್ಪಣಿಗಳು, ಆಲ್ಬಮ್‌ಗಳು ಮತ್ತು ಅಡುಗೆ ಇತಿಹಾಸ ಶಾಶ್ವತವಾಗಿ ಅಳಿಸಲ್ಪಡುತ್ತವೆ.',
  'settings.deleteKeep': 'ಇತರರು ಉಳಿಸಿದ ರೆಸಿಪಿಗಳು ಅವರಿಗೆ ಲಭ್ಯವಿರುತ್ತವೆ.',
  'order.groceryTitle': '{app} ನಲ್ಲಿ ಆರ್ಡರ್ ಮಾಡಿ',
  'order.cartTitle': 'ನಿಮ್ಮ {app} ಕಾರ್ಟ್',
  'order.connectTitle': 'ನಿಮ್ಮ {app} ಖಾತೆಯನ್ನು ಜೋಡಿಸಿ',
  'order.connectBody': 'ನಿಮ್ಮ ಫೋನ್ ನಂಬರ್‌ನಿಂದ {app} ನಲ್ಲಿ ಸೈನ್ ಇನ್ ಮಾಡುತ್ತೀರಿ. ನಂತರ Eat Recipe ಈ ಪಟ್ಟಿಯಿಂದ ನಿಮ್ಮ {app} ಕಾರ್ಟ್ ತುಂಬುತ್ತದೆ; ಪಾವತಿ {app} ನಲ್ಲಿ.',
  'order.connect': '{app} ಜೋಡಿಸಿ',
  'order.connectFailed': '{app} ಜೋಡಿಸುವುದು ಪೂರ್ಣಗೊಳ್ಳಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  'order.emptyList': 'ನಿಮ್ಮ ದಿನಸಿ ಪಟ್ಟಿ ಖಾಲಿಯಾಗಿದೆ.',
  'order.finding': '{app} ನಲ್ಲಿ ನಿಮ್ಮ ವಸ್ತುಗಳನ್ನು ಹುಡುಕುತ್ತಿದ್ದೇವೆ…',
  'order.pickHint': 'ಪ್ರತಿ ವಸ್ತುವಿಗೆ ಪ್ಯಾಕ್ ಆರಿಸಿ. ಮನೆಯಲ್ಲಿರುವ ಸಾಮಾನ್ಯ ವಸ್ತುಗಳನ್ನು ಬಿಟ್ಟಿದ್ದೇವೆ.',
  'order.recipeNeeds': 'ರೆಸಿಪಿಗಳಿಗೆ ಬೇಕು {q}',
  'order.pantry': 'ಸಾಮಾನ್ಯವಾಗಿ ಮನೆಯಲ್ಲಿರುತ್ತದೆ',
  'order.notFound': '{app} ನಲ್ಲಿ ಸಿಗಲಿಲ್ಲ',
  'order.pack': 'ಪ್ಯಾಕ್',
  'order.quantity': 'ಪ್ರಮಾಣ',
  'order.less': 'ಒಂದು ಕಡಿಮೆ',
  'order.more': 'ಇನ್ನೊಂದು',
  'order.build': 'ನನ್ನ {app} ಕಾರ್ಟ್ ತುಂಬಿಸಿ · {n} ವಸ್ತುಗಳು',
  'order.build_one': 'ನನ್ನ {app} ಕಾರ್ಟ್ ತುಂಬಿಸಿ · 1 ವಸ್ತು',
  'order.building': 'ನಿಮ್ಮ ಕಾರ್ಟ್ ತುಂಬಿಸುತ್ತಿದ್ದೇವೆ…',
  'order.payInApp': 'ಬೆಲೆಗಳು {app} ನವು, ಚೆಕ್‌ಔಟ್‌ನಲ್ಲಿ ಬದಲಾಗಬಹುದು. ಡೆಲಿವರಿ ಸಮಯ ಮತ್ತು ಪಾವತಿ {app} ನಲ್ಲಿ ಆರಿಸಿ.',
  'order.openToPay': 'ಪಾವತಿಸಲು {app} ತೆರೆಯಿರಿ',
  'order.cartReady': 'ನಿಮ್ಮ ಕಾರ್ಟ್ ಸಿದ್ಧ — ಚೆಕ್‌ಔಟ್‌ಗೆ {app} ಆ್ಯಪ್ ತೆರೆಯಿರಿ.',
  'order.editItems': 'ವಸ್ತುಗಳನ್ನು ಬದಲಿಸಿ',
  'food.title': '{app} ನಲ್ಲಿ ಆರ್ಡರ್ ಮಾಡಿ',
  'food.connectBody': 'ನಿಮ್ಮ ಫೋನ್ ನಂಬರ್‌ನಿಂದ {app} ನಲ್ಲಿ ಸೈನ್ ಇನ್ ಮಾಡುತ್ತೀರಿ. Eat Recipe ಈ ಖಾದ್ಯವನ್ನು ಹತ್ತಿರದಲ್ಲಿ ಹುಡುಕಿ, ನೀವು ದೃಢೀಕರಿಸಿದ ನಂತರವೇ ಆರ್ಡರ್ ಮಾಡುತ್ತದೆ.',
  'food.deliverTo': 'ಇಲ್ಲಿಗೆ ಡೆಲಿವರಿ',
  'food.address': 'ವಿಳಾಸ',
  'food.change': 'ಬದಲಿಸಿ',
  'food.noAddress': '{app} ನಲ್ಲಿ ಉಳಿಸಿದ ವಿಳಾಸ ಇಲ್ಲ. ಮೊದಲು {app} ಆ್ಯಪ್‌ನಲ್ಲಿ ಸೇರಿಸಿ.',
  'food.dish': 'ಖಾದ್ಯದ ಹೆಸರು',
  'food.search': 'ಹುಡುಕಿ',
  'food.none': 'ಈಗ {app} ನಲ್ಲಿ ಹತ್ತಿರದ ಯಾವ ರೆಸ್ಟೋರೆಂಟ್‌ನಲ್ಲೂ ಇದು ಇಲ್ಲ.',
  'food.soldOut': 'ಮುಗಿದಿದೆ',
  'food.customizable': 'ಆಯ್ಕೆಗಳು ಬೇಕು — ಇದನ್ನು {app} ಆ್ಯಪ್‌ನಲ್ಲಿ ಆರ್ಡರ್ ಮಾಡಿ',
  'food.review': 'ಆರ್ಡರ್ ನೋಡಿ',
  'food.reviewTitle': 'ನಿಮ್ಮ ಆರ್ಡರ್ ನೋಡಿ',
  'food.payWith': 'ಪಾವತಿ ವಿಧಾನ',
  'food.noPayment': 'ಇಲ್ಲಿ ಈ ಆರ್ಡರ್‌ಗೆ {app} ಯಾವುದೇ ಪಾವತಿ ವಿಧಾನ ನೀಡುತ್ತಿಲ್ಲ.',
  'food.note': 'ರೆಸ್ಟೋರೆಂಟ್‌ಗೆ ಟಿಪ್ಪಣಿ (ಐಚ್ಛಿಕ)',
  'food.notePlaceholder': 'ಖಾರ ಕಡಿಮೆ, ಈರುಳ್ಳಿ ಬೇಡ…',
  'food.cancelNote': 'ಆರ್ಡರ್‌ಗಳು ನೇರವಾಗಿ ರೆಸ್ಟೋರೆಂಟ್‌ಗೆ ಹೋಗುತ್ತವೆ. ನಗದು ಆರ್ಡರ್‌ಗಳನ್ನು ಇಲ್ಲಿ ರದ್ದುಮಾಡಲಾಗದು; ಅಗತ್ಯವಿದ್ದರೆ {app} ಸಪೋರ್ಟ್ ಸಂಪರ್ಕಿಸಿ.',
  'food.choosePayment': 'ಹೇಗೆ ಪಾವತಿಸಬೇಕು ಆರಿಸಿ',
  'food.place': 'ಆರ್ಡರ್ ಮಾಡಿ · {total} · {method}',
  'food.placing': 'ನಿಮ್ಮ ಆರ್ಡರ್ ಮಾಡುತ್ತಿದ್ದೇವೆ…',
  'food.doneTitle': 'ನಿಮ್ಮ ಆರ್ಡರ್',
  'food.placed': '{app} ಆರ್ಡರ್ ಆಯಿತು',
  'food.orderId': 'ಆರ್ಡರ್ {id}',
  'food.eta': '{eta} ನಲ್ಲಿ ಬರುತ್ತದೆ',
  'food.refresh': 'ಸ್ಥಿತಿ ನೋಡಿ',
  'food.payNow': 'ನಿಮ್ಮ UPI ಆ್ಯಪ್‌ನಲ್ಲಿ ಪಾವತಿಸಿ',
  'food.payBody': 'ಪಾವತಿ ಆದ ತಕ್ಷಣ ಆರ್ಡರ್ {app} ನಲ್ಲಿ ದಾಖಲಾಗುತ್ತದೆ.',
  'food.openUPI': 'UPI ಆ್ಯಪ್ ತೆರೆಯಿರಿ',
  'food.waiting': 'ಪಾವತಿಗಾಗಿ ಕಾಯುತ್ತಿದ್ದೇವೆ…',
  'food.failed': 'ಆರ್ಡರ್ ಆಗಲಿಲ್ಲ',
  'recipe.orderIt': 'ಮಾಡಲು ಮನಸ್ಸಿಲ್ಲವೇ? {app} ನಲ್ಲಿ ಆರ್ಡರ್ ಮಾಡಿ',
  'grocery.orderOn': '{app} ನಲ್ಲಿ ಆರ್ಡರ್ ಮಾಡಿ',
  'settings.apps': 'ಆರ್ಡರ್ ಆ್ಯಪ್‌ಗಳು',
  'settings.appsHint': 'ದಿನಸಿ ಪಟ್ಟಿಯಿಂದ ಕಾರ್ಟ್ ತುಂಬಿಸಲು ಅಥವಾ ಖಾದ್ಯ ಆರ್ಡರ್ ಮಾಡಲು ಒಂದು ಆ್ಯಪ್ ಜೋಡಿಸಿ.',
  'settings.connected': 'ಜೋಡಿಸಲಾಗಿದೆ',
  'settings.connect': 'ಜೋಡಿಸಿ',
  'settings.disconnect': 'ತೆಗೆಯಿರಿ',
  'settings.appConnected': '{app} ಜೋಡಿಸಲಾಗಿದೆ',
  'settings.appDisconnected': '{app} ತೆಗೆಯಲಾಗಿದೆ',
  'settings.grocery': 'ದಿನಸಿ',
  'settings.food': 'ಫುಡ್ ಡೆಲಿವರಿ',
  'apps.title': 'ಈ ದಿನಸಿ ಆರ್ಡರ್ ಮಾಡಿ',
  'apps.sub': '{n} ರೆಸಿಪಿಗಳಿಂದ. ಆರ್ಡರ್ ಮಾಡಲು ಆ್ಯಪ್ ಆರಿಸಿ.',
  'apps.sub_one': '1 ರೆಸಿಪಿಯಿಂದ. ಆರ್ಡರ್ ಮಾಡಲು ಆ್ಯಪ್ ಆರಿಸಿ.',
  'apps.none': 'ಈ ಸರ್ವರ್‌ನಲ್ಲಿ ಇನ್ನೂ ದಿನಸಿ ಆ್ಯಪ್ ಸೆಟ್ ಆಗಿಲ್ಲ.',
  'apps.signIn': 'ನಿಮ್ಮ ಫೋನ್ ನಂಬರ್‌ನಿಂದ ಸೈನ್ ಇನ್ ಮಾಡಿ',
  'apps.note': 'Eat Recipe ಆ್ಯಪ್‌ನ ಕಾರ್ಟ್ ತುಂಬಿಸಿ ಅದರದೇ ಬೆಲೆಗಳನ್ನು ತೋರಿಸುತ್ತದೆ. ನೀವು ದೃಢೀಕರಿಸುವವರೆಗೆ ಏನೂ ಆರ್ಡರ್ ಆಗುವುದಿಲ್ಲ.',
  'soon.badge': 'ಶೀಘ್ರದಲ್ಲೇ',
  'soon.orderOn': '{apps}ನಲ್ಲಿ ಆರ್ಡರ್',
  'soon.body': '{app} Eat Recipe ಅನ್ನು ಅನುಮೋದಿಸಿದ ತಕ್ಷಣ ಇಲ್ಲಿಂದ ಆರ್ಡರ್ ಮಾಡಬಹುದು.',
  'grocery.orderAll': 'ಈ ದಿನಸಿ ಆರ್ಡರ್ ಮಾಡಿ',
  'order.connectBody2': 'ನಿಮ್ಮ ಫೋನ್ ನಂಬರ್‌ನಿಂದ {app} ನಲ್ಲಿ ಸೈನ್ ಇನ್ ಮಾಡುತ್ತೀರಿ. ನಂತರ Eat Recipe ಈ ಪಟ್ಟಿಯಿಂದ ಕಾರ್ಟ್ ಮಾಡಿ {app} ಬೆಲೆಗಳನ್ನು ತೋರಿಸುತ್ತದೆ; ನೀವು ದೃಢೀಕರಿಸುವವರೆಗೆ ಏನೂ ಆರ್ಡರ್ ಆಗುವುದಿಲ್ಲ.',
  'order.reviewN': 'ಆರ್ಡರ್ ನೋಡಿ · {n} ವಸ್ತುಗಳು',
  'order.reviewN_one': 'ಆರ್ಡರ್ ನೋಡಿ · 1 ವಸ್ತು',
  'order.notDeliverable': 'ಈಗ {app} ಈ ವಿಳಾಸಕ್ಕೆ ಈ ಕಾರ್ಟ್ ಡೆಲಿವರಿ ಮಾಡಲಾಗದು.',
  'order.realOrder': 'ಇದು ನಿಮ್ಮ {app} ಕಾರ್ಟ್‌ನಲ್ಲಿರುವುದನ್ನು ಬದಲಿಸುತ್ತದೆ. ಆರ್ಡರ್ ನಿಜವಾದದ್ದು: {app} ಡೆಲಿವರಿ ಮಾಡಿ, ನೀವು ಆರಿಸಿದ ವಿಧಾನದಲ್ಲಿ ಹಣ ಪಡೆಯುತ್ತದೆ.',
  'order.payTitle': 'ಆರ್ಡರ್ ಪೂರ್ಣಗೊಳಿಸಲು ಪಾವತಿಸಿ',
  'order.payNow': 'ಪಾವತಿ ಪುಟ ತೆರೆಯಿರಿ',
  'order.finishInApp': '{app} ಆ್ಯಪ್‌ನಲ್ಲಿ ಪೂರ್ಣಗೊಳಿಸಿ',
  'order.finishInAppNote': 'ನಿಮ್ಮ ಕಾರ್ಟ್ ಈಗಾಗಲೇ {app} ನಲ್ಲಿದೆ: ಅಲ್ಲಿ ಇನ್ನಷ್ಟು ಸೇರಿಸಿ, ಕೂಪನ್ ಬಳಸಿ, ಪಾವತಿಸಿ.',
  'order.cancelInApp': 'ರದ್ದುಮಾಡಬೇಕೇ? {app} ಆ್ಯಪ್ ತೆರೆಯಿರಿ (ಆರ್ಡರ್ {id}). ಪಾವತಿಸದ ಆರ್ಡರ್‌ಗಳು ಡೆಲಿವರಿ ಆಗುವುದಿಲ್ಲ.',
  'order.pickedOf': '{total} ರಲ್ಲಿ {n} ಆರಿಸಲಾಗಿದೆ',
  'order.basicsLeftOut': 'ಮನೆಯಲ್ಲಿರುವ ಸಾಮಾನ್ಯ ವಸ್ತುಗಳನ್ನು ಬಿಡಲಾಗಿದೆ',
  'order.include': '{item} ಸೇರಿಸಿ',
  'order.otherPacks': 'ಇತರ ಪ್ಯಾಕ್‌ಗಳು',
  'order.itemsFeesNext': '{n} ವಸ್ತುಗಳು · ಶುಲ್ಕ ಮುಂದಿನ ಹಂತದಲ್ಲಿ',
  'order.itemsFeesNext_one': '1 ವಸ್ತು · ಶುಲ್ಕ ಮುಂದಿನ ಹಂತದಲ್ಲಿ',
  'food.dishesNear': 'ನಿಮ್ಮ ಹತ್ತಿರ {n} ಖಾದ್ಯಗಳು',
  'food.dishesNear_one': 'ನಿಮ್ಮ ಹತ್ತಿರ 1 ಖಾದ್ಯ',
  'food.add': 'ಸೇರಿಸಿ',
  'food.soldOutShort': 'ಮುಗಿದಿದೆ',
  'food.optionsInApp': 'ಆಯ್ಕೆಗಳು {app} ನಲ್ಲಿ',
  'food.oneItem': '{n} ವಸ್ತುಗಳು · {total}',
  'food.oneItem_one': '1 ವಸ್ತು · {total}',
  'order.payInApp2': 'ಈ ಆರ್ಡರ್‌ನ ಪಾವತಿ ಪೂರ್ಣಗೊಳಿಸಲು {app} ಆ್ಯಪ್ ತೆರೆಯಿರಿ.',
  'order.checkFirst': 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸುವ ಮೊದಲು, ಎರಡು ಬಾರಿ ಆರ್ಡರ್ ಆಗದಂತೆ {app} ಆ್ಯಪ್‌ನಲ್ಲಿ ನಿಮ್ಮ ಆರ್ಡರ್‌ಗಳನ್ನು ನೋಡಿ.',

  'search.placeholder': 'tomato · rasam · dosa',
  'script.ta': 'ತಮಿಳು',
  'script.en': 'ಇಂಗ್ಲಿಷ್',
  'script.tg': 'Tanglish',
  'cook.done': 'ಮುಗಿಯಿತು',
  'recipe.contentLang': 'ರೆಸಿಪಿಗಳನ್ನು ತಮಿಳು, ಇಂಗ್ಲಿಷ್, Tanglish ನಲ್ಲಿ ಬರೆಯಲಾಗುತ್ತದೆ.',
  'auth.checking': 'ನಿಮ್ಮ ಲಿಂಕ್ ಪರಿಶೀಲಿಸುತ್ತಿದ್ದೇವೆ…',
  'auth.isYou': 'ಇದು ನೀವೇನಾ?',
  'auth.yourAccount': 'ನಿಮ್ಮ ಖಾತೆ',
  'auth.linkFrom': 'ಈ ಲಿಂಕ್ {h} ಜೊತೆಗಿನ ನಿಮ್ಮ ಚಾಟ್‌ನಿಂದ ಬಂದಿದೆ. ಇದು ಒಮ್ಮೆ ಮಾತ್ರ ಕೆಲಸ ಮಾಡುತ್ತದೆ, ಹಾಗಾಗಿ ಬೇರೆ ಯಾರೂ ಇದರಿಂದ ನಿಮ್ಮ ಲೈಬ್ರರಿ ತೆರೆಯಲಾರರು.',
  'auth.continueAs': '{who} ಆಗಿ ಮುಂದುವರಿಸಿ',
  'auth.notYou': 'ನೀವಲ್ಲವೇ? ನಿಮ್ಮದೇ ಲಿಂಕ್ ಪಡೆಯಿರಿ',
  'auth.opening': 'ನಿಮ್ಮ ಲೈಬ್ರರಿ ತೆರೆಯುತ್ತಿದ್ದೇವೆ…',
  'auth.used': 'ಈ ಲಿಂಕ್ ಈಗಾಗಲೇ ಬಳಸಲಾಗಿದೆ',
  'auth.usedBody': 'ಪ್ರತಿ ಲಿಂಕ್ ನಿಮ್ಮ ಲೈಬ್ರರಿಯನ್ನು ಒಮ್ಮೆ, ಸ್ವಲ್ಪ ಸಮಯ ಮಾತ್ರ ತೆರೆಯುತ್ತದೆ. ಹೊಸದು ಕೆಲವೇ ಸೆಕೆಂಡುಗಳಲ್ಲಿ ಸಿಗುತ್ತದೆ.',
  'auth.stepOpen': '{h} ಜೊತೆಗಿನ ನಿಮ್ಮ ಚಾಟ್ ತೆರೆಯಿರಿ',
  'auth.stepSend': '{w} ಕಳುಹಿಸಿ ಹೊಸ ಲಿಂಕ್ ಟ್ಯಾಪ್ ಮಾಡಿ',
  'auth.newLink': 'ಹೊಸ ಲಿಂಕ್ ಪಡೆಯಿರಿ',
  'auth.safe': 'ನೀವು ಉಳಿಸಿದ ರೆಸಿಪಿಗಳು ಸುರಕ್ಷಿತ — ಏನೂ ಕಳೆದುಹೋಗಿಲ್ಲ.',
  'auth.checkFailed': 'ನಿಮ್ಮ ಲಿಂಕ್ ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ',
  'auth.checkConn': 'ದಯವಿಟ್ಟು ಸಂಪರ್ಕ ಪರಿಶೀಲಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  'auth.hello': 'ನಮಸ್ಕಾರ,',
  'auth.friend': 'ಗೆಳೆಯರೇ',
  'auth.summaryEmpty': 'ಯಾವುದಾದರೂ ಅಡುಗೆ ರೀಲ್ ಅನ್ನು @eat.recipe ಗೆ ಹಂಚಿಕೊಳ್ಳಿ, ಅದು ಇಲ್ಲಿ ಕಾಣಿಸುತ್ತದೆ.',
  'auth.summary': 'ನಿಮ್ಮ DM ಗಳಿಂದ {n} ರೆಸಿಪಿಗಳನ್ನು ಉಳಿಸಲಾಗಿದೆ.',
  'auth.summary_one': 'ನಿಮ್ಮ DM ಗಳಿಂದ 1 ರೆಸಿಪಿ ಉಳಿಸಲಾಗಿದೆ.',
  'auth.reading': '{n} ಇನ್ನೂ ಓದುತ್ತಿದ್ದೇವೆ.',
  'auth.reading_one': '1 ಇನ್ನೂ ಓದುತ್ತಿದ್ದೇವೆ.',
  'auth.installBody': 'ಆ್ಯಪ್‌ನಂತೆ ತೆರೆಯುತ್ತದೆ, ಸೈನ್ ಇನ್ ಆಗಿರುತ್ತದೆ, ಕಡಿಮೆ ಡೇಟಾ ಬಳಸುತ್ತದೆ.',
  'auth.openLibrary': 'ನನ್ನ ಲೈಬ್ರರಿ ತೆರೆಯಿರಿ',
  'signin.bubble': 'ಇಗೋ ನಿಮ್ಮ ಒಂದು ಬಾರಿಯ ಲಿಂಕ್. ಲೈಬ್ರರಿ ತೆರೆಯಲು ಟ್ಯಾಪ್ ಮಾಡಿ →',
  'signin.title': 'ನಿಮ್ಮ ರೆಸಿಪಿಗಳು ನಿಮ್ಮ DM ನಲ್ಲಿ ಕಾಯುತ್ತಿವೆ',
  'signin.step1': 'Instagram‌ನಲ್ಲಿ {h} ತೆರೆಯಿರಿ',
  'signin.step2': '{w} ಎಂಬ ಪದ ಕಳುಹಿಸಿ',
  'signin.step3': 'ನಾವು ಕಳುಹಿಸುವ ಲಿಂಕ್ ಟ್ಯಾಪ್ ಮಾಡಿ. ಪಾಸ್‌ವರ್ಡ್ ಎಂದಿಗೂ ಬೇಡ.',
  'signin.message': '@eat.recipe ಗೆ ಮೆಸೇಜ್ ಮಾಡಿ',
  'signin.have': 'ಲಿಂಕ್ ಈಗಾಗಲೇ ಇದೆಯೇ? ಈ ಫೋನ್‌ನಲ್ಲಿ ತೆರೆದರೆ ಸಾಕು.',
};
